import React, { Component } from 'react';
import { Button, Modal, Form, Message } from 'semantic-ui-react'

import { validateTrainingModule, hasValue } from '../../../helpers';

class ModalAddV2TrainingModule extends Component {
  constructor(props){
    super(props);

    this.state = {
      name: '',
      default_frequency: '',
      category: null,
      shec_discipline: null,
      run_time: null,
      delivery: null,
      link: '',
      errorModuleName: false,
      errorDefaultFrequency: false,
      errorCategory: false,
      errorDuplicateModule: false,
      errorList: [],
      existingModules: props.existingModules,
      categories: [
        { key: 'all', text: 'All Staff', value: 'all' },
        { key: 'other', text: 'Team Specific', value: 'other' },
      ],
      shec_disciplines: [
        { key: 'N/A', text: 'N/A', value: '' },
        { key: 'Safety', text: 'Safety', value: 'Safety' },
        { key: 'Health', text: 'Health', value: 'Health' },
        { key: 'Environment', text: 'Environment', value: 'Environment' },
        { key: 'Communities', text: 'Communities', value: 'Communities' },
        { key: 'Integrated SHEC', text: 'Integrated SHEC', value: 'Integrated SHEC' }
      ],
      deliveries: [
        { key: 'N/A', text: 'N/A', value: '' },
        { key: 'Internally', text: 'Internally', value: 'Internally' },
        { key: 'Externally', text: 'Externally', value: 'Externally' },
        { key: 'Online', text: 'Online', value: 'Online' }
      ]
    }
  }

  componentWillReceiveProps(nextProps){
    this.handleErrorMessage(nextProps.errorMessage);
  }

  handleErrorMessage = (errorMessage) => {
    let { errorDuplicateModule } = this.state;
    if (this.props.errorMessage !== errorMessage) {
      errorDuplicateModule = errorMessage && errorMessage.includes("Name has already been taken");
    }
    this.setState({ errorDuplicateModule })
  }

  updateTrainingModule = (trainingModule) => {
    const errors = validateTrainingModule(trainingModule);
    const errorList= Object.values(errors).filter((e) => e);
    let { name, default_frequency, category } = errors;
    const newState = {
      ...trainingModule,
      errorModuleName: hasValue(name),
      errorDefaultFrequency: hasValue(default_frequency), 
      errorCategory: hasValue(category),
      errorDuplicateModule: false,
      errorList,
    };

    this.setState(newState);
    
    return newState;
  } 

  onChangeModule(value){
    const { default_frequency, category } = this.state;
    const trainingModule = { name: value, default_frequency, category };
    this.updateTrainingModule(trainingModule);
  }

  onChangeRefresher(value){
    const { name, category } = this.state;
    const trainingModule = { name, default_frequency: value, category };
    this.updateTrainingModule(trainingModule);
  }

  onChangeCategory(value){
    const { name, default_frequency } = this.state;
    const trainingModule = { name, default_frequency, category: value };
    this.updateTrainingModule(trainingModule);
  }

  onChangeShecDiscipline(value){
    this.setState({
      shec_discipline: value
    })
  }

  onChangeRunTime(value){
    this.setState({
      run_time: value
    })
  }

  onChangeDelivery(value){
    this.setState({
      delivery: value
    })
  }

  onChangeLink(value){
    this.setState({
      link: value
    })
  }

  onAddModule() {
    let { name, default_frequency, category, shec_discipline, run_time, delivery, link, existingModules } = this.state
    const trainingModule = { name, default_frequency, category };
    const newState = this.updateTrainingModule(trainingModule);

    if (newState.errorList.length > 0) return;

    const details = {
      name,
      default_frequency,
      category,
      shec_discipline,
      run_time,
      delivery,
      link
    }
    this.props.onAddEvent(details)
  }

  onModalClose() {
    this.setState({
      name: '',
      default_frequency: '',
      category: null,
      shec_discipline: null,
      run_time: null,
      delivery: null,
      link: '',
      errorModuleName: false,
      errorDefaultFrequency: false,
      errorCategory: false,
      errorDuplicateModule: false,
    })
  }

  onClose() {
    this.props.onClose()
    this.onModalClose()
  }

  getModule = (modules, name) => {
    return modules.find(function(obj, index, arr){
        return obj.name === name
    })
  }

  render() {
    const { show } = this.props
    const { errorModuleName, errorDefaultFrequency, errorCategory, errorDuplicateModule, categories, shec_disciplines, deliveries, errorList } = this.state

    return (
      <Modal size={ 'mini' } dimmer={ 'inverted' } open={ show }>
        <Modal.Header>Add Training Module</Modal.Header>
        <Modal.Content>
          <Form className="custom-form">
            <Form.Input fluid label='Module name' placeholder='Module name' error={ errorModuleName || errorDuplicateModule } onChange={ (target, prop) => this.onChangeModule(prop.value) } />
            { errorDuplicateModule && <Message className="custom-message" error content="A training module with the same name already exists"/> }
            <Form.Input fluid label='Training Frequency (years)' placeholder='Years' type='number' min={0} error={ errorDefaultFrequency } onChange={ (target, prop) => this.onChangeRefresher(prop.value) } />
            <Form.Select fluid label='Requirement' options={categories} placeholder='Requirement' error={ errorCategory } onChange={ (target, prop) => this.onChangeCategory(prop.value) } forceSelection={false} selectOnBlur={false}/>
            { errorList.length > 0 && <Message className="custom-message" error header="The training module requires the following values" list={errorList}/> }
            <Form.Select fluid label='SHEC Discipline' options={shec_disciplines} placeholder='SHEC Discipline' onChange={ (target, prop) => this.onChangeShecDiscipline(prop.value) } />
            <Form.Select fluid label='Facilitator' options={deliveries} placeholder='Facilitator' onChange={ (target, prop) => this.onChangeDelivery(prop.value) } />
            <Form.Input fluid label='Runtime (hours)' placeholder='Runtime (hours)' type='number' min={0} onChange={ (target, prop) => this.onChangeRunTime(prop.value) } />
            <Form.Input fluid label='Link' placeholder='Add a link' onChange={ (target, prop) => this.onChangeLink(prop.value) } />
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button
            negative
            content="Cancel"
            onClick={ () => this.onClose() }
          />
          <Button
            positive
            content="Add"
            onClick={ () => this.onAddModule() }
          />
        </Modal.Actions>
      </Modal>
    )
  }
}

export default ModalAddV2TrainingModule;



// WEBPACK FOOTER //
// ./src/views/components/modals/add_v2_training_module.js